import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
// tslint:disable-next-line:import-blacklist

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable()
export class DashboardService {



  constructor(private http: HttpClient) { }
  // url declarations


  healthUrl = '/superadmin/rest/mgmt/health/count?';
  licenseAnalyticsUrl = '/superadmin/rest/mgmt/account/license/analytics/packages';
  complianceUrl = '/superadmin/rest/mgmt/account/license';
  transactionsUrl = '/superadmin/rest/mgmt/analytics/transactions/count';




  getAccountLicensePackages(filter): Observable<any> {
    return this.http.get(this.licenseAnalyticsUrl + filter, {headers});
  }


  getOutOfComplianceAccounts(filterparam): Observable<any> {

    const day = this.http.get(this.complianceUrl + '/' + 'dayoutofcomplaince' + filterparam, {headers});
    const month = this.http.get(this.complianceUrl + '/' + 'monthoutofcomplaince' + filterparam, {headers});
    const all = this.http.get(this.complianceUrl + '/' + 'outofcomplaince' + filterparam, {headers});
    return forkJoin([day, month, all]);
  //  .map(responses => {
  //     return [].concat(...responses);
  //  });
  }
  getTransactions() {
    return this.http.get(this.transactionsUrl , { headers: headers });
  }
}
